export default "__VITE_ASSET__BxUhRys9__"